module.exports = __webpack_public_path__ + "media/images/faces/male/34-c7455efeaf5ea4c372d6d7274a33a663.jpg";